
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QHourTimeGrid extends Serenity.EntityGrid<QHourTimeRow, any> {
        protected getColumnsKey() { return QHourTimeColumns.columnsKey; }
        protected getDialogType() { return QHourTimeDialog; }
        protected getIdProperty() { return QHourTimeRow.idProperty; }
        protected getInsertPermission() { return QHourTimeRow.insertPermission; }
        protected getLocalTextPrefix() { return QHourTimeRow.localTextPrefix; }
        protected getService() { return QHourTimeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}